import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';

export default class ProjectPartSpecSheetHistory extends BaseModel {
  constructor({
    id,
    status = undefined,
    statusDate = undefined,
    projectPartSpecSheetId = undefined,
  }) {
    super(id, undefined, undefined);
    this.status = status
      ? HitOnlineEnums.getEnumValue(
          'PROJECT_PART_SPEC_SHEET_HISTORY_STATUS',
          status,
          translate,
        )
      : null;
    this.statusDate = statusDate;
    this.projectPartSpecSheetId = projectPartSpecSheetId;
  }

  static get fkName() {
    return 'project_part_spec_sheet_history_id';
  }

  static get apiRoute() {
    return 'project_part_spec_sheet_history';
  }

  static get detailPageRoute() {
    return undefined;
  }

  static get listPageRoute() {
    return undefined;
  }

  get fkName() {
    return ProjectPartSpecSheetHistory.fkName;
  }

  get apiRoute() {
    return ProjectPartSpecSheetHistory.apiRoute;
  }

  get detailPageRoute() {
    return ProjectPartSpecSheetHistory.detailPageRoute;
  }

  get listPageRoute() {
    return ProjectPartSpecSheetHistory.listPageRoute;
  }

  static get joinAttrsKey() {
    return ['status', 'statusDate'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['status', 'statusDate']);
  }

  static get allAttributes() {
    return [
      new AT.EnumerationAttribute({
        name: 'status',
        enumType: 'PROJECT_PART_SPEC_SHEET_HISTORY_STATUS',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-app.common.status',
          maxWidth: '1fr',
        },
      }),
      new AT.DateTimeAttribute({
        name: 'statusDate',
        column: 'status_date',
        tableProperties: {
          header: 'hit-app.common.date',
          maxWidth: '1fr',
        },
      }),
    ];
  }
}
